'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _cart = require('ifeis-isomorphic/lib/redux/actions/cart');

var _currencies = require('../common/utils/currencies');

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

var _ifeisIsomorphic = require('ifeis-isomorphic');

var _setCurrentStage = require('ifeis-isomorphic/lib/redux/actions/stages/setCurrentStage');

var _setCurrentStage2 = _interopRequireDefault(_setCurrentStage);

var _setCurrentEvent = require('ifeis-isomorphic/lib/redux/actions/stages/setCurrentEvent');

var _setCurrentEvent2 = _interopRequireDefault(_setCurrentEvent);

var _setCurrentStewardingDay = require('ifeis-isomorphic/lib/redux/actions/stages/setCurrentStewardingDay');

var _setCurrentStewardingDay2 = _interopRequireDefault(_setCurrentStewardingDay);

var _setCurrentParticipant = require('ifeis-isomorphic/lib/redux/actions/stages/setCurrentParticipant');

var _setCurrentParticipant2 = _interopRequireDefault(_setCurrentParticipant);

var _setCurrentPageSourceForStageStewarding = require('ifeis-isomorphic/lib/redux/actions/stages/setCurrentPageSourceForStageStewarding');

var _setCurrentPageSourceForStageStewarding2 = _interopRequireDefault(_setCurrentPageSourceForStageStewarding);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ParticipantSidenavController = function () {
  function ParticipantSidenavController(fPrompt, fCashCollectDialog, fRegistrationService, fPaymentsService, fPaymentHistoryDialog, fEventService, fAccountService, $scope, $q, $mdDialog, $attrs, fSession, $mdComponentRegistry, msgService, $state, $ngRedux, fPrintCompCards) {
    var _this = this;

    _classCallCheck(this, ParticipantSidenavController);

    this._ = {
      fPrompt: fPrompt,
      fCashCollectDialog: fCashCollectDialog,
      fRegistrationService: fRegistrationService,
      fPaymentsService: fPaymentsService,
      fPaymentHistoryDialog: fPaymentHistoryDialog,
      fEventService: fEventService,
      fAccountService: fAccountService,
      fSession: fSession,
      $mdDialog: $mdDialog,
      $q: $q,
      $scope: $scope,
      msgService: msgService,
      $state: $state,
      $ngRedux: $ngRedux,
      fPrintCompCards: fPrintCompCards
    };

    this.loading = 0;
    this.events = [];

    this._registrations = function () {
      return fRegistrationService.for(_this.feis.id).for(_this.person.id);
    };
    this._payments = function () {
      return fPaymentsService.forAccount(_this.account.id).forFeis(_this.feis.id);
    };
    this._events = function () {
      return fEventService.for(_this.feis.id);
    };
    this.allowRegistration = false;
    this.now = new Date().getTime();
    this.currencyDescription = (0, _currencies.getCurrencyDescription)(this.feis.currency);
    this.longCurrency = (0, _currencies.getLongCurrency)(this.feis.currency);

    $scope.$watch(function () {
      return _this.roles;
    }, function (roles) {
      _this.allowRegistration = angular.isDefined($attrs.allowRegistration) && $attrs.allowRegistration !== 'false' && !_this.feis.is_finalized && (_this.now < _this.feis.dt_reg_end || _this.hasRole('registration')) ? true : false;
    });

    $mdComponentRegistry.when('participant-sidenav').then(function (it) {
      $scope.$watch(function () {
        return it.isOpen();
      }, function (open) {
        if (open) {
          _this.loading = 0;
          _this.getBalance();
          _this.getRegistrations();
        } else {
          _this.loading++;
        }
      });
    });

    this._.$ngRedux.connect(function (state) {
      return {
        balance: _this.account ? state.getIn(['feiseanna', 'carts', _this.feis.id, 'accounts', _this.account.id, 'balance']) : 0
      };
    })(this);
  }

  _createClass(ParticipantSidenavController, [{
    key: 'hasRole',
    value: function hasRole(role) {
      if (this._.fSession.isGod()) {
        return true;
      }

      if (!this.roles) {
        return false;
      }

      return this.roles.indexOf('chair') !== -1 || this.roles.indexOf(role) !== -1;
    }

    /**
     * Competitor Number
     */

  }, {
    key: 'editCompetitorNumber',
    value: function editCompetitorNumber($event) {
      var _this2 = this;

      return this._.fPrompt({
        title: 'Change Competitor Number',
        label: 'Number',
        value: this.person.competitor,
        action: 'Change',
        type: 'number'
      }, $event).then(function (num) {
        if (num !== _this2.person.competitor) {
          _this2._registrations().setNumber(parseInt(num, 10)).then(function () {
            _this2.person.competitor = num;
          }, function (err) {
            return _this2._.msgService.displayErrorMsg('Update failed: ' + err.data.errors[0].detail);
          });
        }
      });
    }
  }, {
    key: 'printCompetitorCard',
    value: function printCompetitorCard() {
      if (this.person.competitor) {
        this._.fPrintCompCards(this.feis.id, this.person);
      } else {
        this._.msgService.displayErrorMsg('Competitor number for this person is not yet assigned.');
      }
    }
  }, {
    key: 'sendEmail',
    value: function sendEmail(email) {
      console.log('Sending email', email); // TODO
    }
  }, {
    key: 'addCredit',
    value: function addCredit($event) {
      var _this3 = this;

      this._.fCashCollectDialog({ value: this.balance > 0 ? this.balance : 0.00 }, $event).then(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            amt = _ref2[0],
            description = _ref2[1];

        return _this3._payments().credit(amt, null, description, _this3.feis.currency);
      }).then(function () {
        return _this3.getBalance();
      }).catch(function (err) {
        return _this3._.msgService.displayErrorMsg(err);
      });
    }
  }, {
    key: 'withAccount',
    value: function withAccount(person_id) {
      var _this4 = this;

      if (person_id === this._accountIsForPerson && this.account) {
        return this._.$q.resolve(this.account);
      }

      delete this.account;
      this._accountIsForPerson = person_id;

      return this._.fAccountService.getFromPerson(person_id).then(function (acct) {
        return _this4.account = acct.get();
      });
    }
  }, {
    key: 'getBalance',
    value: function getBalance() {
      var _this5 = this;

      this.loading++;

      return this.withAccount(this.person.id).then(function (acct) {
        return _this5._.$ngRedux.dispatch((0, _cart.updateCart)(_this5.feis.id, acct.id, true));
      }).then(function () {
        return _this5.loading--;
      }).then(function () {
        return console.log("loading?", _this5.loading);
      });
    }
  }, {
    key: 'getRegistrations',
    value: function getRegistrations() {
      var _this6 = this;

      this.registrations = [];
      this.registrationIds = [];

      this.loading++;
      return this._registrations().all().then(function (regs) {
        _this6.registrations = regs;

        // Tag it as registered
        _this6.registrations.forEach(function (reg) {
          reg.event.$registered = true;
          _this6.registrationIds.push(reg.event.id);
        });

        _this6.loading--;
        return _this6.registrations;
      }, function (err) {
        return _this6._.msgService.displayErrorMsg(err);
      });
    }

    /**
     * Search events
     */

  }, {
    key: 'getEvents',
    value: function getEvents(filter) {
      var _this7 = this;

      return this._events().all({ age: this.person.$feisAge === 'n/a' ? undefined : this.person.$feisAge, filter: filter }).then(function (events) {
        // Get rid of any events for which the user is registered.
        return events.reduce(function (events, event) {
          if (_this7.registrationIds.indexOf(event.id) < 0) {
            events.push(event);
          }

          return events;
        }, []);
      }, function (err) {
        return _this7._.msgService.displayErrorMsg(err);
      });
    }
  }, {
    key: '_removeCurrentEvent',
    value: function _removeCurrentEvent(eventId) {
      this.registrationIds.splice(this.registrationIds.indexOf(eventId), 1);
      for (var i = 0; i < this.registrations.length; i++) {
        if (this.registrations[i].event.id === eventId) {
          this.registrations.splice(i, 1);
          break;
        }
      }
    }
  }, {
    key: '_addCurrentEvent',
    value: function _addCurrentEvent(event) {
      this.registrations.push({ event: event });
      this.registrationIds.push(event.id);
    }

    /**
     * Registration
     */

  }, {
    key: 'register',
    value: function register(event) {
      var _this8 = this;

      // This may fire without an event due to internals of mdAutocomplete (e.g. when search text is
      // blank).
      if (!event) {
        return;
      }

      this._addCurrentEvent(event);

      this.loading++;

      return this._registrations().create(event.id).then(function (reg) {
        // The person may now have a competitor number, so we need to update the person.
        _this8.person.competitor = reg.person.competitor;
      }, function (err) {
        return _this8._.msgService.displayErrorMsg(err);
      }).then(function () {
        return _this8.getBalance();
      }).then(function () {
        return _this8.loading--;
      });
    }
  }, {
    key: 'unregister',
    value: function unregister(event) {
      var _this9 = this;

      this.loading++;

      this._removeCurrentEvent(event.id);

      return this._registrations().delete(event.id).then(function () {
        return _this9.getBalance();
      }).then(function () {
        return _this9.loading--;
      });
    }
  }, {
    key: 'goTo',
    value: function goTo(state, id) {
      var _this10 = this;

      if (state.includes('registration-history') && this.stageId && this.eventId && this.currentStageStewardingDay) {
        Promise.all([this._.$ngRedux.dispatch((0, _setCurrentStewardingDay2.default)(this.feis.id, this.currentStageStewardingDay, false)), this._.$ngRedux.dispatch((0, _setCurrentStage2.default)(this.feis.id, this.stageId, false)), this._.$ngRedux.dispatch((0, _setCurrentPageSourceForStageStewarding2.default)(this.feis.id, 'registration-history')), this._.$ngRedux.dispatch((0, _setCurrentEvent2.default)(this.feis.id, this.eventId, false)), this._.$ngRedux.dispatch((0, _setCurrentParticipant2.default)(this.feis.id, undefined))]).then(function () {
          _this10._.$state.go(state, { participant: id, feis: _this10.feis });
        });
      } else {
        this._.$state.go(state, { participant: id, feis: this.feis });
      }
    }
  }, {
    key: 'openPaymentsDialog',
    value: function openPaymentsDialog(ev) {
      this._.fPaymentHistoryDialog(ev, this.account, this.feis).then(function () {});
    }
  }, {
    key: 'getEventName',
    value: function getEventName(event) {
      if (event) {
        return (0, _ifeisIsomorphic.getDescription)(event);
      }
    }
  }]);

  return ParticipantSidenavController;
}();

exports.default = angular.module('ifeis.participant-sidenav', ['ngMaterial']).directive('fParticipantSidenav', function () {
  return {
    controller: ParticipantSidenavController,
    controllerAs: 'participant',
    bindToController: true,
    template: require('./tpl.html'),
    restrict: 'E',
    transclude: true,
    scope: {
      person: '=',
      feis: '=',
      roles: '=',
      open: '=?',
      stageId: '=?',
      eventId: '=?',
      currentStageStewardingDay: '=?'
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./participant-sidenav/index.js
// module id = 489
// module chunks = 0